// useNavigation.js
import { useNavigate } from 'react-router-dom';

const Navigations = () => {
  const navigate = useNavigate();
  const goBack = () => { navigate(-1); };

  const navigateMain = () => { navigate('/') };
  const navigateRegisteration = () => {
    navigate("/ChooseCountry/");
  };
  const navigateLogin = () => { navigate("/"); };
  const navigateForgotPassword = () => { navigate("/ForgotPassword/"); };
  const navigateOTP = () => { navigate("/OTP/"); };
  const navigateEmailOTP = () => { navigate("/EmailOTP/"); };
  const navigatePrivacyPolicy = () => { navigate("/company/PrivacyPolicy/"); };
  const navigate404 = () => { navigate("/Nofound404/"); };
  const navigateUserType = () => { navigate("/UserType/"); };

  const navigateSellerProductAttributes = () => { navigate("/Product-Attributes/"); };
  const navigateSellerReorderProductAttributes = () => { navigate("/seller/Reorder-Product-Attributes/"); };
  const navigateSellerBulkUploadExcelsheet = () => { navigate("/seller/Bulk-Upload-Productsheet/"); };
  const navigateBulkUploadProducts = () => { navigate("/seller/Bulk-Upload-Products/"); };
  const navigatePlans = (type) => { navigate(`/${type}/plans/`); };

  const navigateBuyerPersonaldetails = () => { navigate("/buyer/Personaldetails/"); };
  const navigateBuyerBusinessdetails = (type) => { 
    // console.log(type)
    navigate(`/Business-details/${type}`);
  };

  // Dashbaord
  const navigateDashboard = (type) => { navigate(`/dashboard/${type}`); };

  // Categories
  const navigateViewCategories = () => { navigate("/seller/categories/View-categories/"); }
  const navigateAddCategory = () => { navigate("/seller/categories/Add-category/"); }
  const navigatesubgategories = (row_id) => { navigate(`/seller/sub-categories/${row_id}`); }
  const navigateEditCategories = (row_id) => { navigate(`/seller/edit-category/${row_id}`); }
  const navigateViewSuppliers = (supplierID, type) => { navigate(`/${type}/suppliers/supplier-products/${supplierID}`); }

  // Products
  const handlenavigateProducts = () => { navigate("/seller/products/View-all-products/"); }
  const handlenavigateAddProducts = () => { navigate("/seller/products/Add-product/"); }
  const navigateEditProduct = (id) => { navigate(`/seller/products/edit-product/${id}`); }
  const navigateProductDetails = (id) => { navigate(`/seller/products/view-product-details/${id}`); }
  const navigateProductPriceList = () => { navigate(`/seller/products/ProductPriceList/`); }
  const navigateAddProductPriceList = () => { navigate(`/seller/products/AddProductPriceList/`); }


  // suppliers
  const handlenavigateViewSupplier = () => { navigate("/suppliers/View-all-suppliers/"); }
  const handlenavigateAddSupplier = () => { navigate("/suppliers/Add-supplier/"); }

  // Orders

  const handlenavigateBuyerOrders = () => { navigate("/buyer/orders/View-Buyer-orders/"); }
  const handlenavigateSellerOrders = () => { navigate("/seller/orders/View-Buyer-orders/"); }
  const navigateOrderDetails = (orderID, type) => { navigate(`/${type}/orders/Order-details/${orderID}`); }


  // Users
  const navigateAddUser = () => { navigate("/seller/users/Add-User/"); }
  const navigateViewUser = () => { navigate("/seller/users/View-Users/"); }

  //settings
  const navigateGeneralSetting = () => { navigate("/seller/GeneralSettings/"); }
  const navigateProductAttributesSetting = () => { navigate("/seller/EditProductAttributes/"); }


  // Plans Cart
  const navigatePlanCart = (id, cur) => { navigate(`/seller/Cart/${cur}/${id}/`); }





  return {
    navigateMain, navigateLogin, navigateForgotPassword, navigatePrivacyPolicy, navigate404, navigateRegisteration, navigateBuyerPersonaldetails, navigateDashboard, navigateBulkUploadProducts, navigatePlans, navigateBuyerBusinessdetails,
    navigateAddCategory, handlenavigateProducts, navigatesubgategories, navigateEditCategories, navigateViewCategories, navigateOTP,navigateEmailOTP, navigateSellerProductAttributes, navigateSellerReorderProductAttributes, navigateSellerBulkUploadExcelsheet, goBack, navigateUserType,
    handlenavigateViewSupplier, handlenavigateAddSupplier, navigateViewSuppliers, handlenavigateBuyerOrders, handlenavigateSellerOrders, navigateOrderDetails, navigateViewUser, navigateAddUser, handlenavigateAddProducts, navigateEditProduct, navigateProductDetails, navigateProductPriceList, navigateGeneralSetting, navigateProductAttributesSetting, navigateAddProductPriceList, navigatePlanCart
  };

};

export default Navigations;
